/**
 * Class strings shared by every pre-auth screen, so login, signup and the password lifecycle all
 * render the same field and the same primary button. Kept out of AuthLayout.tsx so that file only
 * exports components (fast refresh needs that).
 */

/** For `@hrms/ui`'s Input — taller and softer than the in-app density, with the focus glow from
 *  styles.css's `.auth-field`. */
export const authInputClass = 'auth-field h-11 rounded-lg shadow-sm';

/** For the shadcn Input on Signup: the same field, re-pointed from shadcn's palette to our tokens. */
export const authShadcnInputClass =
  'auth-field h-11 rounded-lg border-border bg-surface text-base text-fg shadow-sm placeholder:text-fg-subtle md:text-base dark:bg-surface';

/** For the one primary `Button` on each screen. `group` lets a trailing arrow nudge on hover. */
export const authSubmitClass =
  'group mt-1 h-11 w-full rounded-lg font-semibold shadow-accent transition-all duration-200 hover:-translate-y-px active:translate-y-0';

/** For an icon inside a field, positioned for the 2.75rem (`h-11`) height. */
export const authFieldIconClass =
  'pointer-events-none absolute left-3.5 top-1/2 size-4 -translate-y-1/2 text-fg-subtle';

/** The inline text link style (secondary navigation under a form). */
export const authLinkClass =
  'font-semibold text-accent underline-offset-4 transition-colors hover:text-accent-hover hover:underline';
